// ═══════════════════════════════════════════════════════════
//  src/data/notices.js
//  ─ Add new posts at the TOP of the NOTICES array
//  ─ Types: 'campaign' | 'discount' | 'holiday' | 'info'
//  ─ Set expires: null if the post never expires
//  ─ Set important: true to show a coloured stripe & pin to top
//  ─ Add link: 'https://...' to show a "Visit Website" button
// ═══════════════════════════════════════════════════════════
//
//  ── HOW TO ADD A NEW POST ──────────────────────────────────
//
//  Copy this template and paste it at the TOP of NOTICES:
//
//  {
//    id:        9,                          // increment by 1
//    type:      'campaign',                 // campaign | discount | holiday | info
//    titleJa:   '日本語タイトル',
//    titleEn:   'English Title',
//    bodyJa:    '日本語の本文。詳細をここに書いてください。',
//    bodyEn:    'English body text. Write the details here.',
//    date:      '2026-06-01',               // posted date  YYYY-MM-DD
//    expires:   '2026-07-31',               // expiry date  YYYY-MM-DD  (or null)
//    important: true,                       // true = pinned + coloured stripe
//    link:      null,                       // 'https://...' or null
//  },
//
// ══════════════════════════════════════════════════════════

export const NOTICES = [

  // ── Website Launch ───────────────────────────────────────
  {
    id:        7,
    type:      'campaign',
    titleJa:   '🎉 公式ウェブサイト オープン！',
    titleEn:   '🎉 Official Website Now Live!',
    bodyJa:    '掛川バギー＆アウトドアパークの公式ウェブサイトが2026年5月30日にオープンしました！オンライン予約やキャンペーン情報など、最新情報をこちらからご確認いただけます。',
    bodyEn:    'The official Kakegawa Buggy & Outdoor Park website launched on May 30, 2026! Check here for online reservations, campaigns and the latest park news.',
    date:      '2026-05-30',
    expires:   null,
    important: true,
    link:      'https://kakegawabuggy.jp',
  },

  // ── Grand Opening Campaign ───────────────────────────────
  {
    id:        8,
    type:      'campaign',
    titleJa:   '🏎️ オープン記念キャンペーン！',
    titleEn:   '🏎️ Grand Opening Campaign!',
    bodyJa:    'ウェブサイトオープンを記念して、2026年6月30日まで初回体験のお客様に特別割引をご提供します。ぜひこの機会にバギー体験をお楽しみください！',
    bodyEn:    'To celebrate our website launch, first-time visitors receive a special discount until June 30, 2026. Come enjoy your first buggy adventure!',
    date:      '2026-05-30',
    expires:   '2026-06-30',
    important: true,
    link:      null,
  },

];

// ═══════════════════════════════════════════════════════════
//  TAG CONFIG — do not edit unless you add a new type
// ═══════════════════════════════════════════════════════════
export const NOTICE_TYPES = {
  campaign: {
    labelJa: 'キャンペーン',
    labelEn: 'Campaign',
    emoji:   '🎉',
    color:   '#ea622a',
    bg:      'rgba(234,98,42,0.12)',
    border:  'rgba(234,98,42,0.25)',
  },
  discount: {
    labelJa: '割引情報',
    labelEn: 'Discount',
    emoji:   '💴',
    color:   '#b8860b',
    bg:      'rgba(212,160,23,0.12)',
    border:  'rgba(212,160,23,0.30)',
  },
  holiday: {
    labelJa: '休業・営業変更',
    labelEn: 'Holiday / Hours',
    emoji:   '📅',
    color:   '#2563a8',
    bg:      'rgba(74,144,217,0.12)',
    border:  'rgba(74,144,217,0.28)',
  },
  info: {
    labelJa: 'お知らせ',
    labelEn: 'Info',
    emoji:   'ℹ️',
    color:   '#1f4d2b',
    bg:      'rgba(31,77,43,0.10)',
    border:  'rgba(31,77,43,0.22)',
  },
};